<template>
    <section>
        <div v-if="loading" class="content content-centered">
            <pulse-loader></pulse-loader>
        </div>
        <div v-show="!loading" class="content">
            <div class="box">
                <div class="box-body">
                    <div class="row">
                        <!-- <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div> -->
                    </div>
                    <div id="details">
                        <div class="col-sm-12 text-right">
                            <button class="btn btn-danger mr-5" type="button" @click="deleteTripModal" v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]">Delete Trip</button>
                        </div>
                         <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group " :class="fieldClassName(formstate.vehicleId)">
                                        <label>Vehicle</label>
                                        <select v-model="trip.vehicleId" name="vehicleId" class="form-control">
                                            <option disabled>Select Vehicle</option>
                                            <option v-for="(item,index) in vehicle_no" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="vehicleId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Vehicle is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.deviceId)">
                                        <label>Device</label>
                                        <select v-model="trip.deviceId" required name="deviceId" class="form-control">
                                            <option disabled>Device</option>
                                            <option v-for="(item,index) in device_name" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="deviceId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">device is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverId)">
                                        <label>Driver</label>
                                        <select required v-model="trip.driverId" name="driverId" class="form-control">
                                            <option disabled>Driver</option>
                                            <option v-for="(item,index) in driver_name" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="driverId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Driver is a required field</div>
                                        </field-messages>
                                        
                                    </validate>
                                </div>
                                <div class="col-sm-4">
                                    <label>Scheduled Date</label>
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleDate)">
                                            <date-picker  id="scheduleDate" required v-model="trip.scheduleDate" lang="en" name="scheduleDate" input-class="form-control" width="100%" use-utc="true" format="DD-MM-YYYY"></date-picker>
                                            <field-messages name="scheduleDate" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Schedule Date is a required field</div>
                                                <div slot="pattern">Schedule Date is invalid</div>
                                            </field-messages>
                                    </validate>
                                </div> 
                                <div class="col-sm-2">
                                    <label>Scheduled Time</label>
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleTime)">
                                            <vue-timepicker name="scheduleTime" required v-model="trip.scheduleTime" style="width: 271px"></vue-timepicker>
                                            <field-messages name="scheduleTime" show="$touched || $submitted" class="form-control-feedback">
                                                <div slot="required">Schedule Time is a required field</div>>
                                            </field-messages>
                                    </validate>
                                </div>

                            </div>
                            <div class="col-sm-12">
                               <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.routeId)">
                                        <label>Route Name</label>
                                        <select v-model="trip.routeId" required name="routeId" class="form-control" @change="getSites">
                                            <option disabled>Select Route</option>
                                            <option v-for="(item,index) in route_name" :key="index" v-bind:value="item._id" v-bind:sourceSite="item.startSite" v-bind:destinationSite="item.endSite">
                                                {{item.name}}
                                            </option>
                                        </select>
                                        <field-messages name="routeId" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Route is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regionManager)">
                                        <label>G.A Head</label>
                                        <select v-model="trip.regionManager" required name="regionManager" class="form-control">
                                            <option disabled>Select G.A Head</option>
                                            <option v-for="(item,index) in region_managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">G.A Head is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-sm-3">
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.journeyManager)">
                                        <label>Journey Manager</label>
                                        <select v-model="trip.journeyManager" required name="journeyManager" class="form-control">
                                            <option selected disabled>Select G.A Head</option>
                                            <option v-for="(item,index) in journey_managers" :key="index" :value="item.key">
                                                {{item.value}}
                                            </option>
                                        </select>
                                        <field-messages name="journeyManager" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Journey Manager is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                        </vue-form>
                        <div class="col-sm-12 text-right">
                            <router-link :to="{ name: 'Trip' }">
                                <button class="mr-5 btn btn-default" type="button">Cancel</button>
                            </router-link>
                            <section
                              class="content"
                               v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]"
                            >
                            <button class="mr-2 btn gradientbt" type="submit" @click="updateTrip" >Update Trip</button>
                            </section>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { formService, eventBus , tripService} from '../../../services';
import { EVENTS } from '../../../config';
import Config, { USER_ROLES } from '../../../config';
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
    name: 'tripDetail',
    data () {
        return {
            USER_ROLES : USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: '',
            EVENTS: EVENTS,
            role: {},
            roles: [],
            permissions: [],
            formstate: {},
            region_managers : {},
            vehicle_no :{},
            route_name : {},
            driver_name :{},
            device_name :{},
            journey_managers:{},
            status: 'scheduled',
            sourceSite: '',
            destinationSite:'',
            trip : {},
        }
    },
    mounted: function() {
        this.getTrip()
        this.getRegionManager()
        this.getDriverName()
        this.getDeviceName()
        this.getRouteName()
        this.getVehicle()
        this.getJourneyManager()
    },
    methods: {
        fieldClassName: formService.fieldClassName,
        getTrip () {
            return this.$tripDataRepository.find(this.$route.params._id)
            .then((response) => {
                this.trip = response.data;
                console.log("response of trip",response)
            })
            .catch((error) => {
                this.$snotify.error('Trip detail failed', 'Error!')
            })
        },
        getSites(e){
            this.sourceSite =  e.target.options[e.target.selectedIndex].getAttribute('sourceSite');
            this.destinationSite = e.target.options[e.target.selectedIndex].getAttribute('destinationSite');
        },
        getRegionManager() {
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 2;
            let regionManagerList = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        regionManagerList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.region_managers = regionManagerList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('Region Manager.requestFunction-error:', error)
                    this.$snotify.error('Get region manager list failed', 'Error!')
                })
        },
        getJourneyManager(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            params.roleRank = 3;
            let journeyManagerList = [];
            this.$userRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        journeyManagerList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.firstName +' '+item.lastName
                            }
                        })
                       
                    }
                    this.journey_managers = journeyManagerList;
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('journey Manager.requestFunction-error:', error)
                    this.$snotify.error('Get journey manager list failed', 'Error!')
                })
        },
        getVehicle(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let vehicleList = [];
            this.$vehicleDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        vehicleList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.regNo,
                                
                            }
                        })
                       
                    }
                    this.vehicle_no = vehicleList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('vehicle.requestFunction-error:', error)
                    this.$snotify.error('Get vehicle list failed', 'Error!')
                })
        },
        getDriverName(){
            console.log('hiii',this.user.roleName == 'Journey Manager')
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let driverList= []
            if(this.user.roleName == 'Journey Manager'){
            axios.get(`${Config.serverURI}/regions-drivers?manager=${this.user._id}`)
                .then((res)=> {
                    console.log('hiii 2',res)
                    this.loading  = false;
                    if (res.data.drivers && res.data.drivers) {
                        driverList =  res.data.drivers.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.driverName,
                                
                            }
                        })
                       
                    }
                    console.log('driverList',driverList)
                    this.driver_name = driverList;
                    console.log('driverList',this.driver_name)
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('driver.requestFunction-error:', error)
                    this.$snotify.error('Get driver list failed', 'Error!')
                })
            }else{
            
            this.$driverDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        driverList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.driverName,
                                
                            }
                        })
                       
                    }
                    this.driver_name = driverList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('driver.requestFunction-error:', error)
                    this.$snotify.error('Get driver list failed', 'Error!')
                })
        
            }
        },
        getDeviceName(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            //params.roleRank = 4;
            let deviceList = [];
            this.$deviceDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        deviceList =  res.data.docs.map((item)=> {
                            return {
                                key : item._id, 
                                value : item.deviceId,
                                
                            }
                        })
                       
                    }
                    this.device_name = deviceList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('device.requestFunction-error:', error)
                    this.$snotify.error('Get device list failed', 'Error!')
                })
        },
        getRouteName(){
            this.loading  = true;
            const params  = {}
            params.$limit = 0;
            let routeList = [];
            this.$triprouteDataRepository.list(params)
                .then((res)=> {
                    this.loading  = false;
                    if (res.data.docs) {
                        routeList =  res.data.docs;
                       
                    }
                    this.route_name = routeList;
                    
                })
                .catch((error) => {
                    this.loading  = false;
                    console.error('triproute.requestFunction-error:', error)
                    this.$snotify.error('Get route list failed', 'Error!')
                })
        },
        updateTrip () {
            this.loading = true;
            return tripService.updateTrip(this.trip)
            .then((response) => {
                this.loading = false
                this.flash = false
                this.$snotify.success('Trip details updated!', 'Success!')
                this.$router.push('/trip')
            })
            .catch(error => {
                this.loading = false
                //console.error('TripCreate.createTrip-error:', error)
                this.$snotify.error('Add Trip failed', 'Error!')
                if (error.data.message.includes('must be one of')) {
                    this.flash = true
                    this.flashType = 'error'
                    this.flashMessage = 'Trip is not updated due to some error. Please try again!.'
                }
            })
        },
        deleteTripModal () {
            swal({
                title: 'Are you sure?',
                text: 'This will permanently delete this Trip!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.deleteTrip()
                }
            })
        },
        deleteTrip () {
            this.loading = true
            return this.$tripDataRepository.deleteOne(this.trip._id)
            .then((response) => {
                this.loading = false;
                return swal(
                    'Deleted!',
                    'Trip has been deleted.',
                    'success'
                )
            })
            .then((response) => {
                this.loading = false;
                this.$router.push('/trip')
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error('Delete trip failed', 'Error!')
            })
        },
        formatDate(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            
            return [year, month, day].join('-');
        }
    },
    computed : {
        ...mapState({
            user : state => state.auth.user,
        })
    },
    created() {
        const promises = []
        this.loading = true
        promises.push(this.getTrip())
        Promise.all(promises)
            .then(() => {
                this.loading = false
                this.ready = true
            })
            .catch(() => {
                this.loading = false
            })
    }
}
</script>

<style scoped>
    .required-field > label::after , label::after {
        content: '*';
        color: red;
        margin-left: 0.25rem;
    }
    .form-control-feedback {
        font-weight: 100;
        color: red;
        position: initial;
        text-align: left;
        height: auto;
        width: auto;
    }
    .has-danger {
        color: red
    }
    .swal2-popup{
        font-size: 2rem !important;
    }
    .gradientbt{
        background: #0F6940;
        color: white
    }
</style>



// WEBPACK FOOTER //
// TripDetail.vue?d6b81666